export default [
    'constitutionnalisassions',
    'constitutionnaliseraient',
    'hospitalo-universitaires',
    'oto-rhino-laryngologiste'
];
